<template>
    <div>
        <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
            <!-- 搜索筛选 -->
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-form-item label="所属门店：">
                    <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable size="small" filterable
                        @change="getListData">
                        <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                            :key="item.keyId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="统计时间：">
                    <el-date-picker v-model="inputDate" :type="statisticType" :default-value="new Date()"
                        @change="changeDate" :clearable="false"
                        :value-format="statisticType === 'month' ? 'yyyy-MM' : 'yyyy'"
                        :placeholder="statisticType === 'month' ? '选择月' : '选择年'" :editable="false"
                        :format="statisticType === 'month' ? 'yyyy年MM月' : 'yyyy年'" size="small">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="统计类型：">
                    <el-radio-group v-model="statisticType" size="small" @change="handleChangeStatisticType">
                        <el-radio label="month" selected>月统计</el-radio>
                        <el-radio label="year">年统计</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item class="btnList">
                    <el-button size="small" type="primary" icon="el-icon-search" @click="getListData()">搜索</el-button>
                </el-form-item>
            </el-form>
            <!--列表-->
            <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading" border stripe
                :rowKey="'rowNumber'" :height="700">
                <el-table-column align="center" slot="afterSaleRate" label="⑨售后率 ⑨=⑦/⑧×100%" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.afterSaleRate }}%
                    </template>
                </el-table-column>
            </STable>
        </topTab>
    </div>

</template>

<script>
import {
    GeyAfterSaleOrderStatistic
} from '@/api/storeOrderApi.js';
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
export default {
    data() {
        return {
            activeTab: '1',
            tabData: [{
                key: '1',
                value: '售后统计'
            }],
            loading: false, // 显示加载
            formInline: {
                storeKeyId: "",
                year: new Date().getFullYear(),
                month: new Date().getMonth() + 1
            },
            listData: [],
            statisticType: "month",
            inputDate: new Date(),
            storeList: [],
            columnsData: [], //显示列
            listColumns: [{
                prop: 'rowNumber',
                label: '序号',
                align: 'center',
                width: '60',
            }, {
                prop: 'storeCode',
                label: '门店编号',
                align: 'center',
                width: "80",
            }, , {
                prop: 'storeName',
                label: '所属门店',
                align: 'center',
                width: "120",
            }, {
                prop: 'totalCount',
                label: '①创建订单总数量',
                align: 'center',
            }, {
                prop: 'kdCount',
                label: '②快递订单数量',
                align: 'center',
            },
            {
                prop: 'cheDanCount',
                label: '③撤单数量',
                align: 'center',
            },
            {
                prop: 'afterSaleCount',
                label: '④售后数量',
                align: 'center',
            }, {
                prop: 'waiJiaGongCount',
                label: '⑤外加工数量',
                align: 'center',
            }, {
                prop: 'reWarehouseCount',
                label: '⑥重新出库数量',
                align: 'center',
            }, {
                prop: 'afterSalesTotalCount',
                label: '⑦售后总数量\r\n⑦=④+⑥',
                align: 'center',
                width: "160",
            }, {
                prop: 'realCount',
                label: '⑧实际数量\r\n⑧=②-④-⑤',
                align: 'center',
                width: "170",
            }, {
                slot: 'afterSaleRate',
                label: '⑨售后率\r\n⑨=⑦/⑧×100%',
                align: 'center',
            }
            ],
        };
    },
    // 注册组件
    components: {

    },
    /**
     * 创建完毕
     */
    created() {
        // 初始列
        this.getCheckBox(this.listColumns.map((item) => item.label));
        this.GetOrgInfoListByConfig();
        this.getListData();
    },
    computed: {},
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
        // 获取筛选框
        getCheckBox(val) {
            let arr = this.listColumns.filter((v) => !val.includes(v.label));
            this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
        },
        changePages() { },
        changeDate(val) {
            var list = val.split('-');
            if (this.statisticType === 'month') {
                this.formInline.year = parseInt(list[0]);
                this.formInline.month = parseInt(list[1]);
            } else {
                this.formInline.year = parseInt(list[0]);
                this.formInline.month = 0;
            }
            this.getListData();
        },
        handleChangeStatisticType(val) {
            if (val === 'month') {
                this.formInline.year = new Date().getFullYear();
                this.formInline.month = new Date().getMonth() + 1;
            } else {
                this.formInline.year = new Date().getFullYear();
                this.formInline.month = 0;
            }
            this.getListData();
        },
        // 获取列表
        getListData() {
            GeyAfterSaleOrderStatistic(this.formInline)
                .then((res) => {
                    if (res.code == 1) {
                        this.listData = res.data;
                    } else {
                        this.$message({
                            type: 'info',
                            message: '暂无数据',
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error('数据加载失败，请稍后再试！');
                });
        },
        // 获取所属门店
        GetOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.storeList = [];
                        if (res.code == 1) {
                            res.data.forEach((item) => {
                                this.storeList.push({
                                    keyId: item.keyId,
                                    value: item.name + '【' + item.remark2 + '】',
                                });
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
    },
};
</script>

<style scoped></style>